"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "fengkong-default-page"
  }, [_c("div", {
    staticClass: "version-switch-bar"
  }, [_c("div", {
    staticClass: "version-switch-inner"
  }, [_c("span", {
    staticClass: "version-switch-label"
  }, [_vm._v("报告样式")]), _vm._v(" "), _c("el-radio-group", {
    attrs: {
      value: _vm.viewMode,
      size: "small"
    },
    on: {
      input: _vm.onViewChange
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "new"
    }
  }, [_vm._v("新版")])], 1)], 1)]), _vm._v(" "), _c("fengkong-default-report-new", {
    attrs: {
      data: _vm.data,
      member: _vm.member
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;